/* Fast Bundle price recalc — rewritten 2026-07-30.
   The old version did `priceContainer.innerText = total`, which flattened Dawn's whole
   .price__container to plain text on every size change: the <s> compare-at, "Sale price"
   labels and badges were destroyed, and the number it wrote was the SUM OF FULL per-item
   prices (the .rbr tag .money values are undiscounted), silently displayed as if it were
   the sale price.
   This version:
   - sums the per-item .money tags = the COMPARE-AT (full price) total;
   - captures the bundle discount ratio ONCE from the server-rendered Dawn block
     (initial sale ÷ initial compare, e.g. 481.95/567 = 0.85), so any bundle % works
     without hardcoding;
   - writes sale + compare into Dawn's EXISTING nodes (textContent only), so the
     strikethrough and labels survive;
   - mirrors the site's money format from the initial render (prefix/suffix, e.g. "$… AUD").
*/
document.addEventListener("DOMContentLoaded", () => {
  const priceRoot = () =>
    document.querySelector('.product-price__container .price') ||
    document.querySelector('.price__container')?.closest('.price');

  // capture initial state for ratio + formatting
  let discountRatio = 1;
  let moneyPrefix = "$";
  let moneySuffix = "";

  function parseMoney(text) {
    const m = (text || "").trim().match(/^([^\d]*)([\d,]+(?:\.\d{1,2})?)(.*)$/);
    if (!m) return null;
    return {
      prefix: m[1],
      value: parseFloat(m[2].replace(/,/g, "")),
      suffix: m[3],
    };
  }

  function captureInitial() {
    const root = priceRoot();
    if (!root) return;
    const saleEl = root.querySelector(".price__sale .price-item--sale");
    const compareEl = root.querySelector(".price__sale .price-item--regular");
    const sale = parseMoney(saleEl && saleEl.textContent);
    const compare = parseMoney(compareEl && compareEl.textContent);
    const anyEl = sale ? sale : parseMoney(root.textContent);
    if (anyEl) {
      moneyPrefix = anyEl.prefix || "$";
      moneySuffix = anyEl.suffix || "";
    }
    if (sale && compare && compare.value > 0 && sale.value <= compare.value) {
      discountRatio = sale.value / compare.value;
    }
  }

  function fmt(value) {
    return (
      moneyPrefix +
      value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) +
      moneySuffix
    );
  }

  function updateTotalPrice() {
    let fullTotal = 0;
    let found = 0;
    document
      .querySelectorAll(".rbr-productNamePrice__tag__container .money")
      .forEach((el) => {
        const p = parseMoney(el.textContent);
        if (p) {
          fullTotal += p.value;
          found++;
        }
      });
    if (!found) return;

    const saleTotal = Math.round(fullTotal * discountRatio * 100) / 100;
    const root = priceRoot();
    if (!root) return;

    const saleEl = root.querySelector(".price__sale .price-item--sale");
    const compareEl = root.querySelector(".price__sale .price-item--regular");
    if (saleEl && compareEl && discountRatio < 1) {
      // update text only — never innerText/innerHTML on the container,
      // so the strikethrough node and labels survive
      saleEl.textContent = fmt(saleTotal);
      compareEl.textContent = fmt(fullTotal);
    } else {
      const regEl = root.querySelector(".price__regular .price-item--regular") || saleEl;
      if (regEl) regEl.textContent = fmt(saleTotal);
    }

    // 2026-07-30: the sticky ATC bar's price is otherwise only updated by global.js on the
    // product's OWN variant change — which never fires on bundle products (single hidden
    // variant), so it sat frozen at the default price while sizes changed. Keep it in step.
    const stickyPrice = document.querySelector("[sticky-atc-price]");
    if (stickyPrice) stickyPrice.textContent = fmt(saleTotal);
  }

  function attachSelectListeners() {
    document.querySelectorAll(".rbr-mbap_item_input select").forEach((select) => {
      if (select.dataset.bppcBound) return;
      select.dataset.bppcBound = "1";
      select.addEventListener("change", () => {
        // Fast Bundle updates its per-item tags after the change event; wait a tick
        setTimeout(updateTotalPrice, 50);
        setTimeout(updateTotalPrice, 400);
      });
    });
  }

  const observer = new MutationObserver(() => {
    if (document.querySelectorAll(".rbr-mbap_item_input select").length > 0) {
      captureInitial();
      attachSelectListeners();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
